import React from 'react';
import Wrapper from './Wrapper';

const App = () => <Wrapper />;

export default App;
